import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-show-modal"
// Opens the shared modal as soon as this element is inserted (e.g. via a Turbo Stream response).
export default class extends Controller {
  connect() {
    document.dispatchEvent(new CustomEvent("modal:show"))
  }
}
